import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DialogModule } from "primeng/dialog";
import { VendorInvoiceJournalDetailValue } from "../../../../core/models/orders/vendorInvoiceJournalDetailValue";

@Component({
  selector: "jni-unmatch-url-dialog",
  templateUrl: "./unmatch-url-dialog.component.html",
  styleUrls: ["./unmatch-url-dialog.component.scss"],
  imports: [DialogModule, CommonModule],
})
export class UnmatchUrlDialogComponent {
  @Input() displayModal!: boolean;
  @Input() vendorInvoiceJournalDetail: VendorInvoiceJournalDetailValue[] = [];
  @Output() closeDialogEvent = new EventEmitter();

  closeModalDialog() {
    this.closeDialogEvent.emit();
  }
}
